import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Search } from "../../shared/Search";
import { EmptyList, TListState } from "../../shared/modal";
import { EmptyPOFilter, TPOFilter, TPO, POStatusLabel } from "./modal";
import { Fetch, ILazyParams } from "../../utilities/fetch";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";
import { format } from "date-fns";
import { RequirementInfo } from "../pipeline/RequirementInfo";

type TL = TListState<TPO>;

export const Table = () => {
    const [table, setTable] = useState(EmptyList as TL);
    const [globalSearch, setGlobalSearch] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });
    const [filters, setFilters] = useState<TPOFilter>(EmptyPOFilter);

    const [requirementId, setRequirementId] = useState<number | null>(null);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTable(prev => ({ ...prev, loading: true }));
        const result = await Fetch<TL>("PO",
            {
                query: new URLSearchParams({
                    lazyParams: JSON.stringify(lazyParams),
                    filters: JSON.stringify(filters),
                    ...(globalSearch ? { search: globalSearch } : {})
                }).toString()
            });
        if (result) {
            setTable({ data: result.data, count: result.count, loading: false });
        }
        setTable(prev => ({ ...prev, loading: false }));
    }


    useEffect(() => {
        loadTableData();
    }, [globalSearch, lazyParams, filters]);

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage PO</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalSearch} />
            </span>
        </div>
    );

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: TPOFilter) => setFilters(filters)} loading={table.loading} />
                </AccordionTab>
            </Accordion>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={table.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={table.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Requirement found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={table.loading}
            >
                <Column field="id" header="Req ID"
                    body={(r: TPO) => (
                        <span onClick={() => setRequirementId(r.requirementId)}
                            title="Submit Candidate"
                            className="clickable-id">
                            #{r.requirementId}
                        </span>
                    )}
                />
                <Column field="jobTitle" header="Job Title" />
                <Column field="salesManager" header="Sales Manager" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="candidateName" header="Candidate" />
                <Column field="vendorCompanyName" header="PrimeVendor" />
                <Column field="bRate" header="B Rate" />
                <Column field="sRate" header="S Rate" />
                <Column field="pO_Status" header="PO Status"
                    body={(r: TPO) => (
                        <span className={`po-status po-status-${r.pO_Status}`}>
                            {POStatusLabel[r.pO_Status]}
                        </span>
                    )}
                />
                {/* <Column field="action" header="Action" body={(r: TPO) => (
                    <Button icon="pi pi-history" className="p-button-sm p-button-text" onClick={() => setHistory({ open: true, data: r })} />
                )} /> */}
            </DataTable>
            <RequirementInfo requirementId={requirementId} hideDialog={() => setRequirementId(null)} />
        </>
    );
}
